<template>
    <div>
        <table class="table table-sm table-borderless table-striped">
            <thead>
            <tr>
                <th scope="col">Furnizor</th>
                <th scope="col">Denumire</th>
                <th scope="col">Disponibilitate</th>
                <th scope="col">Preț</th>
                <th></th>
            </tr>
            </thead>
            <tbody>
            <template v-for="product in this.products">
                <tr v-for="stock in product.stocks" :key="stock.id">
                    <td class="nowrap">
                        {{ product.supplier.name }}
                        <b-badge
                                variant="danger"
                                size="sm"
                                v-if="productCountInOfferFromSupplier(product.supplier.id)"
                        >
                            <b-icon icon="file-ruled" />
                            {{ productCountInOfferFromSupplier(product.supplier.id) }}
                        </b-badge>

                        <br>

                        <template v-if="stockInfoUpdated(stock.updated_at)">
                            <span class="small-text" style="color: darkgreen;">Ultima actualizare: {{ formatDate(stock.updated_at) }}</span>
                        </template>
                        <template v-else>
                            <span class="small-text" style="color: darkred; font-weight: 600;">Ultima actualizare: {{ formatDate(stock.updated_at) }}</span>
                        </template>
                    </td>
                    <td class="wrap">
                        {{ product.name }}
                        <br>
                        <div class="product-codes">
                            <span v-if="product.product_info && product.product_info.ean" class="small-text">
                                EAN: <span style="font-weight: 600;">{{product.product_info.ean}}</span>
                            </span>
                            <span v-if="product.product_info && product.product_info.upc" class="small-text">
                                UPC: <span style="font-weight: 600;">{{product.product_info.upc}}</span>
                            </span>
                            <span v-for="code in product.extra_ids" :key="code.id" class="small-text">
                                {{code.type.name}}: <span style="font-weight: 600;">{{code.value}}</span>
                            </span>
                        </div>
                    </td>
                    <td class="nowrap">
                        <span class="mr-2" style="font-weight: 600;">{{ parseFloat(stock.quantity).toFixed(0) }}</span>
                        <b-badge v-if="stock.stock_status === 'IN_STOCK'" variant="success">În stoc</b-badge>
                        <b-badge v-if="stock.stock_status === 'SUPPLIER_STOCK'" variant="warning">Stoc furnizor</b-badge>
                        <b-badge v-if="stock.stock_status === 'OUT_OF_STOCK'" variant="danger">Indisponibil</b-badge>
                        <br>
                        <span class="small-text">{{ stock.stock_type.name }}</span>
                    </td>
                    <td class="nowrap">
                        {{ parseFloat(stock.price).toFixed(2) }} {{ stock.currency }}
                        <br>
                        <span class="small-text">{{parseFloat(stock.ron_price).toFixed(2)}} RON</span>
                    </td>
                    <td style="width: 200px; white-space: nowrap;">
                        <template v-if="!getProductStockFromOffer(stock.id) || editingOffers.length > 0 || editingOrders.length > 0">
                            <ProductAdder :stock-id="stock.id" style="display: inline-block"/>
                        </template>

                        <template v-if="getProductStockFromOffer(stock.id)">
                            <b-button
                                    v-if="editingOffers.length > 0 || editingOrders.length > 0"
                                    size="sm"
                                    variant="danger"
                                    @click="() => onDelete(getProductStockFromOffer(stock.id).item_id)"
                                    class="ml-2"
                                    style="margin-bottom: 1px"
                            >
                                <b-icon icon="trash"/> Șterge
                            </b-button>

                            <b-button
                                    v-else
                                    size="sm"
                                    variant="danger"
                                    @click="() => onDelete(getProductStockFromOffer(stock.id).item_id)"
                            >
                                <b-icon icon="trash"/> Șterge din oferta curentă
                            </b-button>
                        </template>
                    </td>
                </tr>
            </template>
            </tbody>
        </table>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import ProductAdder from "@/components/search/ProductAdder";
    import moment from "moment";

    export default {
        name: "SearchPageTable",
        components: {ProductAdder},
        props: [
            'products'
        ],
        computed: {
            ...mapState(['workingOffer', 'editingOffers', 'editingOrders']),
        },
        methods: {
            productCountInOfferFromSupplier(supplier_id) {
                if(!this.workingOffer.products)
                    return 0;

                let count = 0;
                this.workingOffer.products.forEach(product => {
                    if(product.supplier_id == supplier_id) {
                        count++;
                    }
                });

                return count;
            },
            getProductStockFromOffer(stock_id) {
                if(!this.workingOffer.products)
                    return false;

                let foundProduct = null;
                this.workingOffer.products.forEach(product => {
                    if(product.stock_id == stock_id)
                        foundProduct = product;
                });

                return foundProduct;
            },
            onAdd(stockId) {
                this.$emit('onAdd', {stockId})
            },
            onDelete(itemId) {
                this.$emit('onDelete', {itemId})
            },
            stockInfoUpdated(date) {
                return moment().diff(moment(date), 'days') < 3;
            },
            formatDate(date) {
                return moment(date).format('DD.MM.YYYY kk:mm')
            }
        }
    }
</script>

<style scoped>
    th {
        color: #024A8C;
        font-weight: 600;
    }

    table td {
        white-space: normal;
        vertical-align: middle;
    }

    table td.nowrap {
        width: 1%;
        white-space: nowrap;
    }

    table td.wrap {
      word-wrap: break-word;
      max-width: 1px;
    }

    .small-text {
        color: #6F6F6F;
        font-size: 0.7rem;
    }

    .product-codes {
        word-wrap: break-word;
    }
    .product-codes > span::after {
        content: ';';
    }
</style>